import { SaleOrderCommentTypesEnum } from '@/types'
import * as Yup from 'yup'
import { ModalOrderInfosChangeWarningTypeEnum } from './modal-order-infos-change-warning.type'

export const schema = (t: (key: string) => string) => ({
  reason: Yup.string().required(t('requiredMessage')),
  comment: Yup.string().required(t('requiredMessage')),
})

export type ContentByTypeReturn = Record<
  ModalOrderInfosChangeWarningTypeEnum,
  {
    title: string
    field: string
    description: string
    reasons: { label: string; value: string }[]
  }
>

export const getContentByType = (
  t: (val: string) => string,
): ContentByTypeReturn => ({
  order_item_price: {
    title: t('orderStatusesModalInfosChangeTitle'),
    field: t('orderStatusesModalInfosType_order_item_price'),
    description: t('orderStatusesModalInfosChangeDescription'),
    reasons: [
      {
        label: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
        value: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
        value: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
        value: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionDamagedProduct'),
        value: t('orderStatusesModalInfosChangeReasonOptionDamagedProduct'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionWeightVariation'),
        value: t('orderStatusesModalInfosChangeReasonOptionWeightVariation'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
        value: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionOther'),
        value: t('orderStatusesModalInfosChangeReasonOptionOther'),
      },
    ],
  },
  order_item_quantity: {
    title: t('orderStatusesModalInfosChangeTitle'),
    field: t('orderStatusesModalInfosType_order_item_quantity'),
    description: t('orderStatusesModalInfosChangeDescription'),
    reasons: [
      {
        label: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
        value: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
        value: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
        value: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionDamagedProduct'),
        value: t('orderStatusesModalInfosChangeReasonOptionDamagedProduct'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionWeightVariation'),
        value: t('orderStatusesModalInfosChangeReasonOptionWeightVariation'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
        value: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionOther'),
        value: t('orderStatusesModalInfosChangeReasonOptionOther'),
      },
    ],
  },
  order_item_cost: {
    title: t('orderStatusesModalInfosChangeTitle'),
    field: t('orderStatusesModalInfosType_order_item_cost'),
    description: t('orderStatusesModalInfosChangeDescription'),
    reasons: [
      {
        label: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
        value: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
        value: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
        value: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionDamagedProduct'),
        value: t('orderStatusesModalInfosChangeReasonOptionDamagedProduct'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionWeightVariation'),
        value: t('orderStatusesModalInfosChangeReasonOptionWeightVariation'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
        value: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionOther'),
        value: t('orderStatusesModalInfosChangeReasonOptionOther'),
      },
    ],
  },
  order_shipment_customs_cost: {
    title: t('orderStatusesModalInfosChangeTitle'),
    field: t('orderStatusesModalInfosType_order_shipment_customs_cost'),
    description: t('orderStatusesModalInfosChangeDescription'),
    reasons: [
      {
        label: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
        value: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
        value: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionProductCost'),
        value: t('orderStatusesModalInfosChangeReasonOptionProductCost'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
        value: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionExtraCost'),
        value: t('orderStatusesModalInfosChangeReasonOptionExtraCost'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
        value: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionOther'),
        value: t('orderStatusesModalInfosChangeReasonOptionOther'),
      },
    ],
  },
  order_shipment_first_mile_cost: {
    title: t('orderStatusesModalInfosChangeTitle'),
    field: t('orderStatusesModalInfosType_order_shipment_first_mile_cost'),
    description: t('orderStatusesModalInfosChangeDescription'),
    reasons: [
      {
        label: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
        value: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
        value: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionProductCost'),
        value: t('orderStatusesModalInfosChangeReasonOptionProductCost'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
        value: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionExtraCost'),
        value: t('orderStatusesModalInfosChangeReasonOptionExtraCost'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
        value: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionOther'),
        value: t('orderStatusesModalInfosChangeReasonOptionOther'),
      },
    ],
  },
  order_shipment_last_mile_cost: {
    title: t('orderStatusesModalInfosChangeTitle'),
    field: t('orderStatusesModalInfosType_order_shipment_last_mile_cost'),
    description: t('orderStatusesModalInfosChangeDescription'),
    reasons: [
      {
        label: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
        value: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
        value: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionProductCost'),
        value: t('orderStatusesModalInfosChangeReasonOptionProductCost'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
        value: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionExtraCost'),
        value: t('orderStatusesModalInfosChangeReasonOptionExtraCost'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
        value: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionOther'),
        value: t('orderStatusesModalInfosChangeReasonOptionOther'),
      },
    ],
  },
  order_shipment_extra_cost: {
    title: t('orderStatusesModalInfosChangeTitle'),
    field: t('orderStatusesModalInfosType_order_shipment_extra_cost'),
    description: t('orderStatusesModalInfosChangeDescription'),
    reasons: [
      {
        label: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
        value: t('orderStatusesModalInfosChangeReasonOptionSupplier'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
        value: t('orderStatusesModalInfosChangeReasonOptionProductQuantity'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionProductCost'),
        value: t('orderStatusesModalInfosChangeReasonOptionProductCost'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
        value: t('orderStatusesModalInfosChangeReasonOptionCalculateError'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionExtraCost'),
        value: t('orderStatusesModalInfosChangeReasonOptionExtraCost'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
        value: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionOther'),
        value: t('orderStatusesModalInfosChangeReasonOptionOther'),
      },
    ],
  },
  order_shipment_expected_delivery_at: {
    title: t('orderStatusesModalInfosChangeTitle'),
    field: t('orderStatusesModalInfosType_order_shipment_expected_delivery_at'),
    description: t('orderStatusesModalInfosChangeDescription'),
    reasons: [
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
        value: t('orderStatusesModalInfosChangeReasonOptionCustomerRequest'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionSupplierDelay'),
        value: t('orderStatusesModalInfosChangeReasonOptionSupplierDelay'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionCustomsDelay'),
        value: t('orderStatusesModalInfosChangeReasonOptionCustomsDelay'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionLogisticsDelay'),
        value: t('orderStatusesModalInfosChangeReasonOptionLogisticsDelay'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionClientNoPaid'),
        value: t('orderStatusesModalInfosChangeReasonOptionClientNoPaid'),
      },
      {
        label: t('orderStatusesModalInfosChangeReasonOptionMercaiPolicy'),
        value: t('orderStatusesModalInfosChangeReasonOptionMercaiPolicy'),
      },
    ],
  },
})

export const typesEnum: Record<ModalOrderInfosChangeWarningTypeEnum, string> = {
  order_item_price: SaleOrderCommentTypesEnum.order_item_price,
  order_item_cost: SaleOrderCommentTypesEnum.order_item_cost,
  order_item_quantity: SaleOrderCommentTypesEnum.order_item_quantity,
  order_shipment_customs_cost:
    SaleOrderCommentTypesEnum.order_shipment_customs_cost,
  order_shipment_first_mile_cost:
    SaleOrderCommentTypesEnum.order_shipment_first_mile_cost,
  order_shipment_last_mile_cost:
    SaleOrderCommentTypesEnum.order_shipment_last_mile_cost,
  order_shipment_extra_cost:
    SaleOrderCommentTypesEnum.order_shipment_extra_cost,
  order_shipment_expected_delivery_at:
    SaleOrderCommentTypesEnum.order_shipment_expected_delivery_at,
}
